import type { FeaturedPopup, PavilionEvent, NextPopup } from '../types/popup'

export const currentPopup: FeaturedPopup = {
  name: 'Pimiento',
  tagline: 'Pacific Spice Kitchen',
  chef: 'Chef Maritza Hurtado',
  dateRange: 'Oct 3–11',
  days: [
    { weekday: 'Sat', date: 'Oct 3' },
    { weekday: 'Sun', date: 'Oct 4' },
    { weekday: 'Sat', date: 'Oct 10' },
    { weekday: 'Sun', date: 'Oct 11' },
  ],
  hours: '12 – 6 PM',
  intro:
    'Straight from Tura, Colombia, Chef Maritza brings signature empanadas, rich stews, and standout Colombian seafood to the Bay Area, each dish rooted in heritage and full of soul. The Food Pavilion is thrilled to welcome her back!',
  video:
    'https://cdn.magicpatterns.com/uploads/dHQTcFVAZZBShnwciEs7SB/pimiento animation.mp4',
  chefImage:
    'https://cdn.magicpatterns.com/uploads/45qynt2Y5sxTnJUcWJoRmP/Logo_with_chef_(1).png',
  chefPhoto:
    'https://cdn.magicpatterns.com/uploads/tHnaUPfiGcYaQurU21kkff/Chef_Maritza_Hutado_(1).jpg',
  bio: [
    "For Chef Maritza, cooking was never just a skill. It was inherited. Raised in the kitchens of Tura, Colombia, she learned at her mother Mama Gaby's side, standing close as stews simmered and flavors came together with care. Even as a little girl, Maritza couldn't help but experiment, always asking, \"Mama, try this… what if we add that herb?\" A question that would shape the rest of her life.",
    'That curiosity never faded. She grew into cooking full meals for her family, working with herbs her mother grew and ingredients gathered fresh from the local market. A pressure cooker received one Christmas became her most treasured possession, and a humble kerosene stove became the site of everyday magic.',
    'Life took her down other paths for a while. She studied journalism and produced commercials in Colombia, but her heart never left the kitchen. Throughout her career there, she had the honor of cooking for political leaders and other notable public figures, pouring the same love and care into every plate no matter who sat at the table.',
    'Eventually, Chef Maritza made her way to America, bringing the flavors of Tura with her. Her food today centers on her signature empanadas, alongside rich, soulful stews and standout Colombian seafood dishes, each one carrying the coconut, ancestral fruits, and exotic herbs of her heritage. Through Pimiento Kitchen, that lifetime of tradition meets creativity in every dish she serves.',
  ],
  menuUrl:
    'https://cdn.magicpatterns.com/uploads/fdEUbTuWAso61uWr8tA2B3/Pimiento_Menu_(2).pdf',
  instagram: {
    handle: '@pimiento_catering',
    url: 'https://www.instagram.com/pimiento_catering/',
  },
  website: { label: 'conpimiento.com', url: 'https://conpimiento.com' },
  platos: [
    {
      name: 'Coconut Shrimp',
      price: '$22',
      description: 'Served with steamed rice and sweet plantains.',
    },
    {
      name: 'Breaded Chicken Fillet',
      price: '$18',
      description: 'Crispy fried chicken served with black beans and rice.',
    },
    {
      name: 'Chicharrón Bowl',
      price: '$18',
      description:
        'Chicharrón, sweet plantains, spicy cabbage and steamed rice.',
    },
    {
      name: 'Fried Tilapia Fillet',
      price: '$19',
      description: 'Served with green plantain, steamed rice and spicy onion.',
    },
    {
      name: 'Mussels with Coconut Sauce',
      price: '$25',
      description: 'Mussels in coconut sauce served with steamed rice.',
    },
  ],
  empanadas: {
    price: '$6.50',
    flavors: [
      'Beef & Potato',
      'Cheese & Spinach',
      'Chicken & Potato',
    ],
  },
  menuNote:
    'Plus sweet plantains, spicy cabbage, black beans, puff pastry and mango lemonade.',
}

export const pavilionEvent: PavilionEvent = {
  label: 'Pavilion Celebration',
  days: [
    { weekday: 'Sat', date: 'Oct 17' },
    { weekday: 'Sun', date: 'Oct 18' },
    { weekday: 'Mon', date: 'Oct 19' },
  ],
  description:
    "Join us for a special three-day celebration of the Food Pavilion's 2nd Anniversary.",
  note: '',
  video:
    'https://cdn.magicpatterns.com/uploads/2ZT7eJfUrPSqppqZytDd7X/foodpavilion logo animation_teal.mp4',
}

export const nextPopup: NextPopup = {
  name: 'Fusion Rolls',
  days: [
    { weekday: 'Sat', date: 'Oct 24' },
    { weekday: 'Sun', date: 'Oct 25' },
    { weekday: 'Sat', date: 'Oct 31' },
    { weekday: 'Sun', date: 'Nov 1' },
  ],
  logo: 'https://cdn.magicpatterns.com/uploads/oDvjMdRQgqv3RC3gE2M44R/IMG_7202.png',
  note: 'Menu reveal coming soon.',
}
